import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { LocationInfoMap } from '../../interfaces';
import { getCityName } from '../../utils';

@Component({
  selector: 'fin-dapi-included-product-heading',
  templateUrl: './included-product-heading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DapiIncludedProductHeadingComponent implements OnInit, OnChanges {
  @Input() locationCodes: string[] = [];

  @Input()
  locations: LocationInfoMap;

  @Input()
  operatedByText: string | undefined;

  showLocations: string[];

  ngOnInit(): void {
    this.showLocations = this.locationCodes.map((locationCode) => getCityName(locationCode, this.locations));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['locationCodes']?.firstChange) {
      this.showLocations = this.locationCodes.map((locationCode) => getCityName(locationCode, this.locations));
    }
  }
}
